import { Group, Image as KonvaImage, Rect, Text } from 'react-konva';
import React, { useEffect, useState } from 'react';

const FloorPlanImage = ({ shape, shapeRefs, isSelected, onSelect, onDragEnd, onTransformEnd }) => {
    const [image, setImage] = useState(null);

    const labelHeight = 20;
    const labelWidth = 70;

    useEffect(() => {
        const img = new window.Image();
        img.src = shape.src;
        img.onload = () => setImage(img);
    }, [shape.src]);

    if (!image) return null;

    return (
        <Group
            x={shape.x}
            y={shape.y}
            draggable
            onClick={(e) => onSelect(e, shape.id)}
            onDragEnd={(e) => onDragEnd(e, shape.id)}
            onTransformEnd={(e) => onTransformEnd(e, shape.id)}
            ref={(node) => {
                if (shapeRefs?.current) {
                    shapeRefs.current[shape.id] = node;
                }
            }}
        >
            {!isSelected && <Rect
                width={shape.width}
                height={shape.height}
                stroke="#007AFF"
                dash={[4, 4]}
                strokeWidth={1.5}
            />}
            <KonvaImage
                image={image}
                width={shape.width}
                height={shape.height}
            />
            {!isSelected && <Rect
                x={(shape.width - labelWidth) / 2}
                y={- labelHeight / 2 - 2}
                width={labelWidth}
                height={labelHeight}
                fill="#007AFF"
                cornerRadius={4}
            />}
            {!isSelected && <Text
                x={(shape.width - labelWidth) / 2}
                y={- labelHeight / 2 - 2}
                width={labelWidth}
                height={labelHeight}
                text="3D Map"
                fill="white"
                align="center"
                verticalAlign="middle"
                fontSize={12}
            />}
        </Group>

    );
};

export default FloorPlanImage;